import { HardDrive } from 'lucide-react'

import { Select, type SelectProps } from '../../base'

export type NasStoragePickerProps<T extends string = string> = Omit<SelectProps<T>, 'bordered'>

export const NasStoragePicker = <T extends string>({ options, ...props }: NasStoragePickerProps<T>) => (
  <Select
    {...props}
    bordered
    options={options.map(option => ({
      ...option,
      triggerLabel: (
        <span className="flex min-w-0 items-center gap-1.5">
          <HardDrive className="size-4 shrink-0" />
          <span className="truncate">{option.triggerLabel ?? option.label}</span>
        </span>
      ),
    }))}
  />
)
